export function IsIE(): boolean {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
    return true;
  }
  return false;
}

export function ClientWidth(): number {
  return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
}

export function IsMobile(width = 512): boolean {
  return ClientWidth() < width;
}
